import { CopyButton } from "../common/CopyButton";

export function McpSummaryCard({
  eyebrow,
  tone,
  value,
}: {
  eyebrow: string;
  tone: "emerald" | "slate";
  value: string;
}) {
  const toneStyles = {
    emerald:
      "border-emerald-200/80 bg-emerald-50/80 text-emerald-900 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-100",
    slate:
      "border-slate-200/80 bg-slate-50/80 text-slate-900 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-100",
  };

  return (
    <div className={`border px-3 py-3 ${toneStyles[tone]}`}>
      <p className="font-mono text-[10px] font-bold uppercase tracking-[0.24em] opacity-80">
        {eyebrow}
      </p>
      <p className="mt-2 font-mono text-sm font-semibold">{value}</p>
    </div>
  );
}

export function McpEndpointTile({ endpoint }: { endpoint: string }) {
  return (
    <div className="border border-slate-300 bg-gradient-to-r from-slate-100 via-white to-slate-50 p-3 dark:border-slate-700 dark:from-slate-900/80 dark:via-slate-950/30 dark:to-slate-950/40">
      <p className="font-mono text-[10px] font-bold uppercase tracking-[0.24em] text-slate-700 dark:text-slate-200">
        Endpoint
      </p>
      <div className="mt-3 flex flex-col gap-3 lg:flex-row lg:items-center">
        <div className="min-w-0 flex-1 overflow-x-auto border border-slate-200 bg-white/90 px-3 py-2 font-mono text-xs text-slate-700 dark:border-slate-700 dark:bg-slate-950/50 dark:text-slate-200">
          {endpoint}
        </div>
        <CopyButton text={endpoint} />
      </div>
    </div>
  );
}
